import React, { useState } from "react";
import { useLocationInfo } from "../../../hooks/location";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import css from "./Info.module.css";
import { LocationInfoResponse } from "./LocationInfo";

const NodeLocationInfo = ({ location, color, userColorFlag }) => {
  const { locationInfo, isLoading } = useLocationInfo(location);
  const [statusOpen, setStatusOpen] = useState(false);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto auto",
        gridRowGap: "10px",
      }}
    >
      <span>
        <b>Location: </b>
        <span
          className={css.infoLocationLink}
          onClick={() => setStatusOpen(!statusOpen)}
        >
          {location}
        </span>{" "}
        &nbsp;
        {userColorFlag ? null : <FontAwesomeIcon icon="circle" color={color} size="1x" />}
      </span>
      {statusOpen ? (
        <OpenedResponse locationInfo={locationInfo} isLoading={isLoading} />
      ) : null}
    </div>
  );
};

export default NodeLocationInfo;

const OpenedResponse = ({ locationInfo, isLoading }) => {
  return isLoading ? (
    <FontAwesomeIcon icon="spinner" spin style={{ placeSelf: "center" }} />
  ) : (
    <div
      style={{
        maxHeight: "15rem",
        overflow: "scroll",
        width: "95%",
        display: "grid",
      }}
    >
      <div style={{ width: "90%", height: "100%", placeSelf: "center" }}>
        {order.map((k) => {
          return locationInfo[k] ? (
            <LocationInfoResponse
              key={k}
              locationInfo={locationInfo}
              label={locLabels[k]}
              value={k}
              keyLocLinks={k in links ? links[k] : null}
            />
          ) : null;
        })}
      </div>
    </div>
  );
};

const order = [
  "accession",
  "gene_ontology",
  "is_a",
  "interesting_references",
  "description",
];

const locLabels = {
  accession: "Accession",
  gene_ontology: "GO",
  is_a: "Is a",
  interesting_references: "Interesting references",
  description: "Description",
};

const links = {
  accession: "accession",
  gene_ontology: "go",
};
